module.exports = __webpack_public_path__ + "img/trading.60cebfaa.c09653cd.svg";